/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import classNames from 'classnames';
import FalconCardHeader from 'components/common/FalconCardHeader';
import ChartDownloadButton from './ChartDownloadButton';
import { isEmpty } from 'lodash';
import { FiInfo } from 'react-icons/fi';
import Model from './Model';
import SeasonalBarBody from './SeasonalBarBody';

const MultiYearBarChart = ({ data }) => {
  const [selectedYear, setSelectedYear] = useState(null);
  const [filteredData, setFilteredData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedLegend, setSelectedLegend] = useState(null);
  const [desc, setDesc] = useState('');

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  // Initialize selected year when data changes
  useEffect(() => {
    if (data && data.variant && data.variant.length > 0) {
      const defaultYear = data.variant.find(year => data.data?.[year]);
      setSelectedYear(defaultYear || null);
    } else {
      setSelectedYear(null);
    }
  }, [data]);

  // Update filtered data when selected year changes
  useEffect(() => {
    if (selectedYear && data?.data?.[selectedYear]) {
      setFilteredData({
        year: selectedYear,
        data: data.data[selectedYear],
        series: data.series,
        unit: data.unit
      });
    } else {
      setFilteredData(null);
    }
  }, [selectedYear, data]);

  const handleSelectChange = e => {
    setSelectedYear(e.target.value);
  };

  const handleLegendSelect = legend => {
    setSelectedLegend(legend);
    setDesc(data.info?.[legend] || '');
  };

  return (
    <Card className={classNames('h-100', 'overflow-hidden')}>
      <FalconCardHeader
        title={data?.label}
        titleTag="h5"
        light={true}
        desc={data?.desc}
        endEl={
          data?.variant?.length > 0 && (
            <Row className="align-items-center">
              <Col xs={8} className="ps-2 py-0">
                <Form.Select
                  className="ps-2 py-0"
                  value={selectedYear || ''}
                  onChange={handleSelectChange}
                >
                  {data.variant.map(year => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </Form.Select>
              </Col>
              <Col xs={4} className="ps-2 py-0">
                {filteredData && (
                  <ChartDownloadButton
                    key={data?.label}
                    chartData={Object.values(filteredData.data)}
                    series={Object.keys(filteredData.data)}
                    xAxis={filteredData.series}
                    filename={`${data?.label}`}
                  />
                )}
              </Col>
            </Row>
          )
        }
        infoBtn={
          !isEmpty(data?.description) && <FiInfo onClick={handleShowModal} />
        }
      />
      <Card.Body className="h-100 px-3" dir="ltr">
        {filteredData ? (
          <>
            <p className="units-text">{filteredData.unit}</p>
            <SeasonalBarBody
              landCoverChartData={filteredData}
              onLegendSelect={handleLegendSelect}
            />
          </>
        ) : (
          <p className="text-center text-muted">No data available </p>
        )}
      </Card.Body>
      <Card.Footer>
        {desc && (
          <h5 className="infrence-info">
            {selectedLegend}: {desc}
          </h5>
        )}
      </Card.Footer>
      <Model
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        description={data?.description || {}}
        title={data?.label}
      />
    </Card>
  );
};

export default MultiYearBarChart;
